<template>
  <div class="case-list">
    <!--导航-->
    <div class="dk-nav">
      <nav-bar title="成功案例" url="/home" />
    </div>

    <!--成功案例列表-->
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
    <div style="margin-top: 1px; margin-bottom: 1px;">
      <template v-if="loading">
      <template v-if="cases.data">
      <div class="van-cell" style="margin-bottom: 3px;" v-for="item in filterBy(cases.data,city)" @click="goUrl('/case/detail/'+item.id)">
        <div class="van-image" style="width: 80px; height: 85px; margin-right: 5px;">
          <img :src="uploadsUrl+item.picture" class="van-image__img" style="object-fit: cover;">
        </div>

        <div class="van-cell__title">
          <span>{{item.title}}</span>
          <div class="van-cell__label van-multi-ellipsis--l3">{{item.description}}</div>
        </div>
      </div>
      </template>
      </template>
      <template v-else>
        <van-loading type="spinner" color="#09f" vertical />
      </template>
    </div>
    </van-pull-refresh>

  </div>
</template>

<script>
import {mapState,mapActions} from 'vuex'
import NavBar from '../../components/NavBar.vue'
export default {
    'name': 'caseList',
    data() {
        return {
          isLoading: false,
          loading: false
        };
    },
    computed: {
        ...mapState({
            city: state => state.cityData.city,
            cases: state => state.cases.cases_list
        })
    },
    methods: {
      ...mapActions(['requestCases']),
        goUrl(val) {
            return this.$router.push({path: val})
        },
        onClickLeft() {
            this.$router.push({path: '/'});
        },
        filterBy(list,value){
            return list.filter(function(lists){
                if(value == "重庆") {
                  return lists.city.match('市辖区');
                }else{
                  return lists.city.match(value);
                }
            })
        },
        onRefresh() {
          setTimeout(() => {
            this.isLoading = false;
          }, 1000);
        }
    },
    components: {
      NavBar
    },
    mounted() {
      this.requestCases({"thit":this,"city":this.city});
    },
    beforeCreate() {
        this.uploadsUrl = 'https://a.chengdai.cn/uploads/'
    }
};
</script>

<style scoped>
.home >>> .van-grid-item__icon {
  font-size: 1.3rem;
}

/*导航*/
.dk-nav {
  width: 100%;
  height: 52px;
}
.case-list >>> .van-nav-bar {
  z-index: 9;
  background-color: #ff8917;
  padding-top: 6px;
}
.case-list >>> .van-nav-bar__text {
  color: #fff;
}
.case-list >>> .van-nav-bar__title {
  color: #fff;
}
.case-list >>> .van-card__thumb img {
  border-radius: 0.1rem;
}
.case-list >>> .van-nav-bar .van-icon {
  color: #fff;
}
</style>
